module.exports = __webpack_public_path__ + "img/g-search.233808f1.svg";